var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74999977,20.25 L9.74999977,14.25 L14.2499998,14.25 L14.2499998,20.25 L20.2499998,20.25 L20.2499998,11.25 C20.2499998,11.0510278 20.1712414,10.8601478 20.030625,10.719375 L12.530625,3.219375 C12.3899488,3.07854222 12.1990569,2.99941001 12,2.99941001 C11.8009431,2.99941001 11.6100512,3.07854222 11.469375,3.219375 L3.969375,10.719375 C3.82875857,10.8601478 3.74999977,11.0510278 3.74999977,11.25 L3.74999977,20.25 L9.74999977,20.25 Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgHome);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/home.055ce915a322a04d1b56146cf32be8ac.svg";